import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'manage-state-license',
    initialState: {
        isOpen: false,
        isBlocked: '',
        isUnblocked: '',
        statusAction: 'READY',
    },
    actions: ['BLOCK_LICENSE', 'UNBLOCK_LICENSE', 'SHOW_GESTIONE_STATO_DIALOG'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.BLOCK_LICENSE_SUCCESS:
                return {
                    ...state,
                    isBlocked: action.payload.isBlocked
                };

            case types.UNBLOCK_LICENSE_SUCCESS:
                return {
                    ...state,
                    isUnblocked: action.payload.isUnblocked
                }; 

            case types.SHOW_GESTIONE_STATO_DIALOG:
                return {
                    ...state,
                    isOpen: !state.isOpen
                };


            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //blockLicense
        blockLicenseRequest: (pk, codiceUtente) => ({
            type: types.BLOCK_LICENSE_REQUEST,
            payload: { pk, codiceUtente },
        }),
        blockLicenseSuccess: ({ isBlocked }) => ({
            type: types.BLOCK_LICENSE_SUCCESS,
            payload: { isBlocked },
        }),
        blockLicenseFailed: error => ({ type: types.BLOCK_LICENSE_FAILED, error: true, payload: { error } }),

        //unblockLicense
        unblockLicenseRequest: (pk, codiceUtente) => ({
            type: types.UNBLOCK_LICENSE_REQUEST,
            payload: { pk, codiceUtente },
        }),
        unblockLicenseSuccess: ({ isUnblocked }) => ({
            type: types.UNBLOCK_LICENSE_SUCCESS,
            payload: { isUnblocked },
        }),
        unblockLicenseFailed: error => ({ type: types.UNBLOCK_LICENSE_FAILED, error: true, payload: { error } }),

        showGestioneStatoDialog: () => ({
            type: types.SHOW_GESTIONE_STATO_DIALOG,
        }),
    }),
});
